import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["totalInput", "quantityInput", "unitPriceInput"];

  autocomplete(event) {
    const dataset = event.detail.selected.dataset;

    this.quantityInputTarget.value = dataset.autocompleteQuantity;
    this.unitPriceInputTarget.value = dataset.autocompletePrice;

    this.calculate();
  }

  connect() {
    const observer = new MutationObserver((mutations) => {
      // if an elment is added to the DOM or removed from the DOM dispatch the total event
      mutations.forEach((mutation) => {
        if (mutation.type === "childList") {
          //	this.dispatch("total");
          const addedElements = Array.from(mutation.addedNodes).filter(
            (n) => n.nodeType === Node.ELEMENT_NODE,
          );
          const removedElements = Array.from(mutation.removedNodes).filter(
            (n) => n.nodeType === Node.ELEMENT_NODE,
          );

          if (addedElements.length > 0 || removedElements.length > 0) {
            this.dispatch("total");
          }
        }
      });
    });

    observer.observe(this.element.parentElement, {
      childList: true,
      subtree: true,
    });

    this.calculate();
  }

  calculate() {
    let total =
      parseFloat(this.quantityInputTarget.value) *
      parseFloat(this.unitPriceInputTarget.value);

    if (isNaN(total)) {
      total = 0;
    }

    this.totalInputTarget.value = total.toFixed(2);

    this.dispatch("total");
  }

  total() {
    return parseFloat(this.totalInputTarget.value);
  }
}
